import Layout from "../components/Partials/Layout";

export default function LaqiraPayPage() {
  return (
    <Layout>
      <div>laqira pay</div>
    </Layout>
  );
}
